import React from 'react';
const items = [{
  label: 'Main system',
  name: 'Speech Therapy Clinical Toolkit™',
  detail: 'The complete professional speech therapy resource system for pediatric + adult practice.'
}, {
  label: 'Plus',
  name: '5 premium bonuses',
  detail: 'Additional professional resources supporting planning, caregivers, activities, progress monitoring and school-based practice.'
}];
export function WhatYouGet() {
  return <section className="bg-ivory py-11 sm:py-14" aria-labelledby="included-title" data-id="element-179" data-mp="1du3fu24h84r9">
      <div className="mx-auto max-w-2xl px-5 sm:px-8" data-id="element-180" data-mp="1iqbqp3bn5bsm">
        <h2 id="included-title" className="text-center font-display text-[24px] font-semibold uppercase leading-tight tracking-tightish text-navy-deep sm:text-3xl" data-id="element-181" data-mp="142z3la66qy04">
          Everything you need.
          <br data-id="element-182" data-mp="1wq34b2y8wq63" />
          One organized system.
        </h2>

        <dl className="mt-6 divide-y divide-navy/10 border-y border-navy/10 sm:mt-8" data-id="element-183" data-mp="21i4ln3a9t72z">
          {items.map((item, index) => <div key={item.name} className="py-5 text-center" data-id="element-184" data-mp="2vglt78wsqp66" data-mpi={index}>
              <p className={`text-[10.5px] font-semibold uppercase tracking-[0.18em] sm:text-xs ${index === 0 ? 'text-gold' : 'text-navy-soft'}`} data-id="element-185" data-mp="2qgzh52spfeyy">
                {item.label}
              </p>
              <dt className={`mt-1.5 font-display font-semibold uppercase leading-tight text-navy-deep ${index === 0 ? 'text-[22px] sm:text-3xl' : 'text-[17px] sm:text-xl'}`} data-id="element-186" data-mp="30dm01m1gzvyc">
                {item.name}
              </dt>
              <dd className="mx-auto mt-1.5 max-w-md text-[13.5px] leading-snug text-navy-soft sm:text-[15px]" data-id="element-187" data-mp="3o3zl2sln0ujf">
                {item.detail}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}